// extracted by mini-css-extract-plugin
export default {"WalletManagement":"WalletManagement_WalletManagement__zYnD5"};